module.exports = __webpack_public_path__ + "img/home5-5.ae9e14a1.png";